<template>
  <div class="container">
    <header
      v-if="!$stringHelper.isNullOrWhitespace($texts.accountAssociationInformationMessage)"
    >
      <h2 class="search-title">{{ $texts.titleFormRegisterCard }}</h2>
      <div class="alert alert-info alert-required-fields" role="alert">
        {{ $texts.accountAssociationInformationMessage }}
      </div>
    </header>

    <main>
      <association-mail-search
        :inputData="inputData"
        :authenticateBy="this.accountDetectionModesModule.flowADM"
        :linking="linking"
        v-if="!loading && !loadingError"
      ></association-mail-search>
      <admin-loader :loading="loading" v-else-if="!loadingError"></admin-loader>
      <div v-else class="alert alert-danger">
        {{ $texts.formLoadingError }}
      </div>
    </main>
    <footer-panel
      :silentRefreshUrl="$appSettings.SilentRefreshUrl"
    ></footer-panel>
  </div>
</template>

<script>
import Vue from "vue";
import AdminLoader from "../../../Commons/AdminLoader.vue";
import AssociationMailSearch from "@/InscriptionFlow/components/association/AssociationMailSearch.vue";
import { InscriptionFlowService } from "@/InscriptionFlow/services/InscriptionFlowService";
import FooterPanel from "@/Commons/components/FooterPanel.vue";
import { getModule } from "vuex-module-decorators";
import { AccountDetectionModeModule } from "@/InscriptionFlowsAdmin/store/modules/AccountDetectionModeModule";
import { AccountDetectionModes } from "@/InscriptionFlow/models/enums/AccountDetectionModes";

export default Vue.extend({
  name: "form-account-detection",

  components: {
    FooterPanel,
    AdminLoader,
    AssociationMailSearch,
  },

  props: {
    name: {
      type: String,
      required: true,
    },
    linking: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      inputData: null,
      loading: false,
      loadingError: null,
      accountDetectionModesModule: getModule(AccountDetectionModeModule),
    };
  },

  computed: {},

  methods: {
    async getAccountDetectionInputData(name) {
      this.loading = true;
      try {
        this.inputData = await (this.accountDetectionModesModule.flowADM ===
        AccountDetectionModes.Email
          ? InscriptionFlowService.getEmail(name)
          : InscriptionFlowService.getNationalId(name));
        this.loading = false;
      } catch (e) {
        this.loadingError = e;
      }
    },
  },

  watch: {
    name: {
      immediate: true,
      handler(val) {
        this.getAccountDetectionInputData(val);
      },
    },
  },
});
</script>

<style scoped>
header {
  text-align: left;
  padding-bottom: 15px;
  margin-bottom: 15px;
  width: 75%;
  margin: 0 auto;
}
main {
  text-align: left;
  width: 75%;
  margin: 0 auto;
}
.search-title {
  text-align: left;
  margin-left: 15px;
}
</style>
